export default [
{
    url:/caveindia.com/,
    base:"cave",
    title:"CAVE",
    description:"Enjoy films, entertainment shows, originals, music and much more. Cave instantly connects to a bouquet of curated content across genres, be it thriller, drama, action, romance, game and info.",
    keywords:"cave, webapp, movies"
},

{//default fallback...
    url:/.+/,
    base:"cave",
    title:"CAVE",
    description:"Enjoy films, entertainment shows, originals, music and much more. Cave instantly connects to a bouquet of curated content across genres, be it thriller, drama, action, romance, game and info.",
    keywords:"cave, webapp, movies"
},
]